import { useEffect } from 'react';
import { useTitleSectionsStore, type SectionId } from "../../../journal-title-sections";

export const useTrackActiveSection = () => {
  const setActiveSection = useTitleSectionsStore((state) => state.setActiveSection);
  const openedSections = useTitleSectionsStore((state) => state.openedSections);

  useEffect(() => {
    const openedSectionIds = Object.entries(openedSections)
      .filter(([, isOpen]) => isOpen)
      .map(([id]) => id as SectionId);

    if (openedSectionIds.length > 0) {
      setActiveSection(openedSectionIds[0]);
    } else {
      setActiveSection(null);
    }
  }, [openedSections, setActiveSection]);
};

